<!-- components/HighRiskCountryPopup.vue BR#181 pop-up notification in MU regarding high risk countries - mbeng-->
<template>
  <div
    v-if="visible"
   class="popup-overlay"
  >
    <!-- Popup -->
    <div
      class="popup-content"
    >
      
      <div>
        <p>
        {{ $t("as-part-of-our-standard-onboarding-and-compliance-procedures") }}
       </p>
        <br>
        <p><a
            :href="computedPdfUrl || null"
            target="_blank"
            rel="noopener noreferrer"
            class="text-blue-600 hover:underline { 'pointer-events-none opacity-50': !computedPdfUrl }"
        >
            {{ $t("click-here-to-download") }}
        </a></p>
        <br>
        <p>
            {{ $t("once-completed-you-may-upload-the-signed") }}
        </p>
        
      <button
        @click="$emit('close')"
        class="text-white font-bold bg-opacity-50 hover:bg-opacity-80 rounded-full p-2 z-10"
        style="background-color: #004A81;"
      >
      ok
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HighRiskCountryPopup",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  emits: ["close"],
  data() {
    return {
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data","get_country_risk_map"]),
    userLanguage() {
        return this.get_profile?.profile?.language;
    },
   
    computedPdfUrl() {
      const lang = this.$store.getters.get_lang || 'en';  

      const mapICMMU = {
        en: '/ICMMU-Source-of-Funds-and-Wealth-Declaration-Form.pdf',
        ar: '/ICMMU-Source-of-Funds-and-Wealth-Declaration-Form-AR.pdf',
      };

      const whitelabel = process.env.VUE_APP_WHITELABEL;

      if (whitelabel === 'ICMMU') {
        return mapICMMU[lang] || mapICMMU.en;
      } 

      return mapICMMU.en; // fallback

    }
  }
};
</script>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
